import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  StorageAllocationOverviewResponse,
  StorageAllocationsForOperatorParams,
} from 'src/apis/storage/types';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageServiceRoot: StorageServiceRootRequest;
  params: StorageAllocationsForOperatorParams;
};

type ExecuteOptions = {
  url: string;
  params: StorageAllocationsForOperatorParams;
};

export function useStorageAllocationsForOperator({
  storageServiceRoot,
  params,
}: HookOptions) {
  const storageAllocations = useAxios(
    (axios, baseConfig, { url, params }: ExecuteOptions) =>
      axios.request<StorageAllocationOverviewResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageServiceRoot.response) return;

    const allocationsLink =
      storageServiceRoot.response.data._links
        .getAllocationsOverviewForOperator!; // we are checking for the link in the parent component

    const url = urlTemplate.parse(allocationsLink.href).expand({});

    storageAllocations.execute({
      url,
      params,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageServiceRoot.response, params]);

  return storageAllocations;
}

export type StorageAllocationsForOperatorRequest = ReturnType<
  typeof useStorageAllocationsForOperator
>;
